import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { CourseThemeListItemServerResponse } from '@models/courseTheme'
import getThemeRoute from '@utils/getThemeRoute'
import FlexWrapper from '@organisms/FlexWrapper'
import Badge from '@organisms/Badge'
import GrayButton from '@organisms/GrayButton'
import { useTheme } from '@emotion/react'
import { ProgressStatuses } from '@enums/ProgressStatuses'
import { Number, RightWrapper, Wrapper } from './styled'

type Props = {
  courseIri: string
  educationId: string | number
  number: string
  isClientCourse?: boolean
  onControlQuestion?: (themeId: number) => void
} & CourseThemeListItemServerResponse

const Theme: FC<Props> = ({
  number,
  id,
  title,
  courseIri,
  educationId,
  currentListenerStatus,
  isClientCourse = false,
  hasControlQuestion = false,
  onControlQuestion,
}) => {
  const navigate = useNavigate()
  const {
    colors: { warning, success, disable },
  } = useTheme()

  const handleClick = () => {
    navigate(getThemeRoute(id, courseIri, educationId))
  }

  const handleControlQuestion = (e: React.MouseEvent) => {
    e.stopPropagation()
    if (onControlQuestion) {
      onControlQuestion(id)
      return
    }

    navigate(getThemeRoute(id, courseIri, educationId), {
      state: { openControlQuestion: true },
    })
  }

  const badgeColor = !currentListenerStatus
    ? 'none'
    : currentListenerStatus === ProgressStatuses.PASSED
    ? success
    : currentListenerStatus === ProgressStatuses.IN_PROCESS
    ? warning
    : disable

  return (
    <Wrapper key={id} onClick={handleClick}>
      <FlexWrapper>
        <Number>{number}</Number>
        {title}
      </FlexWrapper>
      <RightWrapper>
        {/* Контрольный вопрос есть только у клиентских курсов (у общих он вшит в
            SCORM), поэтому и кнопка — только для клиентских, и только у тем, где вопрос
            реально задан. Внутри самой темы это условие уже стоит, тут его раньше не
            было. */}
        {isClientCourse &&
          hasControlQuestion &&
          currentListenerStatus === ProgressStatuses.IN_PROCESS && (
          <GrayButton onClick={handleControlQuestion}>
            Ответить на контрольный вопрос
          </GrayButton>
        )}
        <Badge badgeColor={badgeColor} />
      </RightWrapper>
    </Wrapper>
  )
}

export default Theme
